import type { FC } from "react"

import { AttachFilesDialog } from "@/components/upload/AttachFilesDialog/AttachFilesDialog"
import type { FieldGroupEnum } from "@/graphql/codegen/graphql"
import { ReferenceTableName } from "@/graphql/codegen/graphql"
import { CUSTOMER_PRODUCT_FILE_TYPE_MAPPING } from "@/screens/CustomerProducts/constants"
import type { Option } from "@/types/form-fields"

interface CustomerProductFileDialogProps {
  onClose: () => void
  onRefresh: () => void
  companyProductAssociationLocationId: string
}

const documentTypeOptions: Option<FieldGroupEnum>[] = Object.entries(CUSTOMER_PRODUCT_FILE_TYPE_MAPPING).map(
  ([value, config]) => ({
    value: value as FieldGroupEnum,
    label: config.label,
  })
)

export const CustomerProductFileDialog: FC<CustomerProductFileDialogProps> = ({
  onClose,
  onRefresh,
  companyProductAssociationLocationId,
}) => (
  <AttachFilesDialog
    title='Attach File'
    referenceTableName={ReferenceTableName.CustomerProductPreference}
    referenceId={companyProductAssociationLocationId}
    documentTypeOptions={documentTypeOptions}
    successMessage='Files uploaded'
    testIdPrefix='customer-product-file'
    dialogTestId='customer-product-file-dialog'
    maxWidth='md'
    onClose={onClose}
    onSuccess={onRefresh}
  />
)
